module.exports = __webpack_public_path__ + "static/media/reservationfound.9d5ec9d5.png";